import { render, staticRenderFns } from "./device_setting.vue?vue&type=template&id=584f0d4c&scoped=true"
import script from "./device_setting.vue?vue&type=script&lang=js"
export * from "./device_setting.vue?vue&type=script&lang=js"
import style0 from "./device_setting.vue?vue&type=style&index=0&id=584f0d4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f0d4c",
  null
  
)

export default component.exports